<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.car_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="car_decode">
            <label class="weui-form-preview__label">{{
              customLabel.car_decode || "需求单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_decode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_name">
            <label class="weui-form-preview__label">{{
              customLabel.de_name || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_custname">
            <label class="weui-form-preview__label">{{
              customLabel.de_custname || "需求来源"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_product_type">
            <label class="weui-form-preview__label">{{
              customLabel.de_product_type || "产品类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_product_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_emname">
            <label class="weui-form-preview__label">{{
              customLabel.de_emname || "需求人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_dpname">
            <label class="weui-form-preview__label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_dpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_project_classify">
            <label class="weui-form-preview__label">{{
              customLabel.car_project_classify || "项目分类"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_project_classify
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_project_level">
            <label class="weui-form-preview__label">{{
              customLabel.car_project_level || "项目等级"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_project_level
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_emname">
            <label class="weui-form-preview__label">{{
              customLabel.car_emname || "项目负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_budget">
            <label class="weui-form-preview__label">{{
              customLabel.car_budget || "项目预算金额"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_budget
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_invest_cost">
            <label class="weui-form-preview__label">{{
              customLabel.car_invest_cost || "投入成本"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_invest_cost
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_research_cost">
            <label class="weui-form-preview__label">{{
              customLabel.car_research_cost || "研发成本"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_research_cost
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_equipment_cost">
            <label class="weui-form-preview__label">{{
              customLabel.car_equipment_cost || "设备投入成本"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_equipment_cost
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_competitor_price">
            <label class="weui-form-preview__label">{{
              customLabel.car_competitor_price || "竞品价格分析"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_competitor_price
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_material_cost">
            <label class="weui-form-preview__label">{{
              customLabel.car_material_cost || "材料成本"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_material_cost
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_labor_cost">
            <label class="weui-form-preview__label">{{
              customLabel.car_labor_cost || "人工成本"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_labor_cost
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_item_cost">
            <label class="weui-form-preview__label">{{
              customLabel.car_item_cost || "项目投入成本"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_item_cost
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_product_apportion_cost">
            <label class="weui-form-preview__label">{{
              customLabel.car_product_apportion_cost || "产品分摊成本"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_product_apportion_cost
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_product_price">
            <label class="weui-form-preview__label">{{
              customLabel.car_product_price || "预估产品售价"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_product_price
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_product_profit">
            <label class="weui-form-preview__label">{{
              customLabel.car_product_profit || "预估产品毛利率(%)"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_product_profit
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="car_currency">
            <label class="weui-form-preview__label">{{
              customLabel.car_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.car_currency
            }}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.car_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/plm/cost_report_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary">编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/plm/costAnalyseReport",
      codeField: "car_code",
      statusField: "car_statuscode",
      caller: "CostAnalyseReport",
      xtype: "plm-costanalysereport-formpanel",
    };
  },
};
</script>
